module.exports = __webpack_public_path__ + "img/email.da8d685b.svg";